import { render, staticRenderFns } from "./winCandidateList.vue?vue&type=template&id=5f81bf88&scoped=true"
import script from "./winCandidateList.vue?vue&type=script&lang=js"
export * from "./winCandidateList.vue?vue&type=script&lang=js"
import style0 from "./winCandidateList.vue?vue&type=style&index=0&id=5f81bf88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81bf88",
  null
  
)

export default component.exports